import { AnyAction } from 'redux';

const actions = {
  show: 'SHOW_OVERLAY',
  hide: 'HIDE_OVERLAY'
};

// initial
const initialState = {
  show: false
};

// actions
export const show = (dispatch: any) => dispatch({ type: actions.show });
export const hide = (dispatch: any) => dispatch({ type: actions.hide });

// reducer
export default function OverlayReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.show: {
      return { show: true };
    }
    case actions.hide: {
      return { show: false };
    }
    default:
      return state;
  }
}
